import * as core from '../../../../../../../core'
import * as deployOutcome from '../deploy-outcome'

export const RESOURCE = {
  payload: {
    description: 'The deployment succeeded',
    enumId: core.dms.models.Enum.Id.from({
      partialId: deployOutcome.RESOURCE.payload.partialId,
    }),
    id: 'SUCCESS',
    name: 'Success',
  },
  type: core.quiver.Resource.Type.DmsEnumEntry,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnumEntry>
